import * as types from './orderActionTypes.js';

export const setProductionOrders = (productionOrders) => ({ type: types.SET_PRODUCTIONORDERS, productionOrders: productionOrders });
export const setMaterials = (materials) => ({ type: types.SET_MATERIALS, materials: materials });
export const setArticles = (articles) => ({ type: types.SET_ARTICLES, articles: articles });
export const refreshOrders = (refreshOrders) => ({ type: types.REFRESH_ORDERS, refreshOrders: refreshOrders });
export const setFinishedOrderIds =  (finishedOrderIds) => ({ type: types.SET_FINISHEDORDERIDS, finishedOrderIds: finishedOrderIds });

